/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  InputField,
  PhoneInput,
  DashboardIntro,
  MyMessage,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  FOLDERS,
  image_kit_folder,
  isKeyHasAnEmptyValue,
} from "../utils/Utils";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import GenerateFullContentData from "../utils/GenerateContent";
import { useAdminContext } from "../../../context/admin/context/AdminContext";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [venue, setVenue] = useState(null);
  const [venueCapacity, setVenueCapacity] = useState(0);
  const [repeatEvery, setRepeatEvery] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [eventStatus, setEventStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [expo, setExpo] = useState(0);
  const [showTop, setShowTop] = useState(0);
  const [pricing, setPricing] = useState([]);
  const [payLink, setPayLink] = useState(null);

  const objectStructure = {
    thumbnail: "",
    thumbnailId: "",
    title: "",
    venue: "",
    venueCapacity: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    email: "",
    phoneNumber: "",
    whatsapp: "",
    facebook: "",
    twitter: "",
    instagram: "",
    youtube: "",
    hashtags: "",
    googleMapCode: "",
    latitude: "",
    longitude: "",
    formattedAddress: "",
    description: "",
    pricing: [{ currency: "", name: "", amount: 0, quantity: 1, status: 1 }],
  };

  const [showGenerateContent, setShowGenerateContent] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const eventRoutes = "/data/event";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setTitle(null);
    setVenue(null);
    setVenueCapacity(null);
    setThumbnail(null);
    setThumbnailId(null);
    setStartDate(null);
    setEndDate(null);
    setStartTime(null);
    setEndTime(null);
    setRepeatEvery(null);
    setExpo(0);
    setEmail(null);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress(null);
    setFeatured(0);
    setShowTop(0);
    setDescription(null);
    setPricing([]);
    setPayLink(null);
  };

  const responses = (error, message) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "city",
      venue: venue,
      venue_capacity: String(venueCapacity),
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: `${String(phoneNumber)?.replace(/\s+/g, "")}`,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: eventStatus,
      featured: featured,
      promoted: promoted,
      repeat_every:
        repeatEvery ||
        "monday|tuesday|wednesday|thursday|friday|saturday|sunday",
      expo: expo,
      show_top: showTop,
      pricing,
      pay_link: payLink,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.EVENT,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "px-4 sm:px-5 py-4";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: eventRoutes }} />
        </div>

        {showGenerateContent ? (
          <GenerateFullContentData
            type="event"
            setShowModal={setShowGenerateContent}
            structure={objectStructure}
            onGenerated={(content) => {
              setThumbnail(content?.image?.image_kit_url);
              setThumbnailId(
                isKeyHasAnEmptyValue(content?.image?.image_kit_file_id)
              );
              setTitle(isKeyHasAnEmptyValue(content?.title));
              setVenue(isKeyHasAnEmptyValue(content?.venue));
              setVenueCapacity(parseInt(content?.venueCapacity) || 2);
              setStartDate(
                isKeyHasAnEmptyValue(
                  content?.startDate,
                  new Date().toDateString()
                )
              );
              setEndDate(
                isKeyHasAnEmptyValue(content?.endDate, new Date().toDateString)
              );
              setStartTime(isKeyHasAnEmptyValue(content?.startTime, "00:00"));
              setEndTime(isKeyHasAnEmptyValue((content?.endTime, "00:00")));
              setEmail(
                isKeyHasAnEmptyValue(content?.email, "info@doseeafrica.com")
              );
              setPhoneNumber(
                `${String(content?.phoneNumber).replace(/\D/g, "")}`
              );
              setPayLink(content?.pay_link);
              setWhatsapp(content?.whatsapp);
              setFacebook(content?.facebook);
              setTwitter(content?.twitter);
              setInstagram(content?.instagram);
              setYoutube(content?.youtube);
              setHashtags(content?.hashtags);
              setGoogleMapCode(content?.googleMapCode);
              setLatitude(content?.latitude);
              setLongitude(content?.longitude);
              setFormattedAddress(content?.formattedAddress);
              setDescription(content?.description);
              setPricing(content?.pricing?.length > 0 ? content?.pricing : []);
              setRepeatEvery(
                "monday|tuesday|wednesday|thursday|friday|saturday|sunday"
              );
            }}
          />
        ) : null}

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Add Event`, name: entry_label }} />
        </div>

        <form onSubmit={addOneEventHandler}>
          <div className="flex flex-col items-center justify-center font-medium text-sm md:text-base gap-6">
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />

            {/* Media & quick actions */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <div className="flex items-center justify-between">
                  <Title props={{ title: "Cover Image" }} />
                  {isSuperAdmin ? (
                    <MyButton
                      title="Generate Event"
                      className="py-2.5 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-500"
                      onClick={() => setShowGenerateContent(true)}
                    />
                  ) : null}
                </div>
              </div>
              <div className={sectionPad}>
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={image_kit_folder(country_name, FOLDERS.EVENTS)}
                />
              </div>
            </div>

            {/* Event details */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Event Details" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  <InputField
                    props={{
                      id: "title",
                      title: "Title",
                      type: "text",
                      required: true,
                      value: title ? title : "",
                      onChange: (e) => {
                        setTitle(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "top",
                      title: "Show In Top Events",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        if (e.target.selectedIndex === 0) setShowTop(0);
                        else setShowTop(1);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "venue",
                      title: "Venue",
                      type: "text",
                      value: venue ? venue : "",
                      onChange: (e) => {
                        setVenue(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "venue_capacity",
                      title: "Venue Capacity",
                      type: "number",
                      value: venueCapacity ? venueCapacity : "",
                      onChange: (e) => {
                        setVenueCapacity(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "formatted_address",
                      title: "Formatted Address",
                      type: "address",
                      value: formattedAddress ? formattedAddress : "",
                      onChange: (e) => {
                        setFormattedAddress(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Date & time */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Date & Time" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <InputField
                    props={{
                      id: "start_date",
                      title: "Start Date",
                      type: "date",
                      value: startDate ? startDate : "",
                      onChange: (e) => {
                        setStartDate(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "end_date",
                      title: "End Date",
                      type: "date",
                      value: endDate ? endDate : "",
                      onChange: (e) => {
                        setEndDate(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "start_time",
                      title: "Start Time",
                      type: "time",
                      value: startTime ? startTime : "",
                      onChange: (e) => {
                        setStartTime(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "end_time",
                      title: "End Time",
                      type: "time",
                      value: endTime ? endTime : "",
                      onChange: (e) => {
                        setEndTime(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>

                {/* Repeat every */}
                <div className="mt-5">
                  <p className="text-sm font-medium text-slate-700">
                    Repeat Every:
                  </p>
                  <div className="flex gap-4 overflow-x-auto w-full text-sm py-3">
                    {[
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                      "sunday",
                      "annual",
                    ].map((val, key) => (
                      <div
                        key={key}
                        className="flex flex-col items-center capitalize min-w-[72px]"
                      >
                        <span className="text-slate-700">{val}</span>
                        {repeatEvery?.toString().split("|").includes(val) ? (
                          <MdCheckBox
                            onClick={() => {
                              let rep = "";
                              repeatEvery
                                ?.split("|")
                                .filter((day) => val !== day)
                                .map((weekday) => (rep += `${weekday}|`));
                              setRepeatEvery(rep);
                            }}
                            className="text-2xl text-blue-600 cursor-pointer"
                          />
                        ) : (
                          <MdCheckBoxOutlineBlank
                            onClick={() => {
                              let rep = "";
                              if (repeatEvery) {
                                [...repeatEvery.split("|"), val].map(
                                  (weekday) => (rep += `${weekday}|`)
                                );
                                setRepeatEvery(rep);
                              } else {
                                setRepeatEvery(val);
                              }
                            }}
                            className="text-2xl text-slate-400 cursor-pointer"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Pricing" }} />
              </div>
              <div className={sectionPad}>
                <Pricing pricing={pricing} setPricing={setPricing} />
              </div>
            </div>

            {/* Contact info */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Contact Info" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="flex flex-row justify-center items-center">
                    <PhoneInput
                      setPhone={setPhoneNumber}
                      phone={phoneNumber}
                      required={false}
                    />
                  </div>
                  <InputField
                    props={{
                      id: "email",
                      title: "Email Address",
                      type: "email",
                      value: email ? email : "",
                      onChange: (e) => {
                        setEmail(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "pay-link",
                      title: "Pay Link (Optional)",
                      type: "text",
                      value: payLink ? payLink : null,
                      onChange: (e) => {
                        setPayLink(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Social contact */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Social Contact" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  <InputField
                    props={{
                      id: "whatsapp",
                      title: "Whatsapp",
                      type: "text",
                      value: whatsapp ? whatsapp : "",
                      onChange: (e) => {
                        setWhatsapp(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "facebook",
                      title: "Facebook",
                      type: "text",
                      value: facebook ? facebook : "",
                      onChange: (e) => {
                        setFacebook(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "twitter",
                      title: "Twitter",
                      type: "text",
                      value: twitter ? twitter : "",
                      onChange: (e) => {
                        setTwitter(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "instagram",
                      title: "Instagram",
                      type: "text",
                      value: instagram ? instagram : "",
                      onChange: (e) => {
                        setInstagram(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "youtube",
                      title: "YouTube",
                      type: "text",
                      value: youtube ? youtube : "",
                      onChange: (e) => {
                        setYoutube(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Geo position */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "Geo Position" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                  <InputField
                    props={{
                      id: "google_map_code",
                      title: "Google Map Code",
                      type: "text",
                      value: googleMapCode ? googleMapCode : "",
                      onChange: (e) => {
                        setGoogleMapCode(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "latitude",
                      title: "Latitude",
                      type: "text",
                      value: latitude ? latitude : "",
                      onChange: (e) => {
                        setLatitude(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "longitude",
                      title: "Longitude",
                      type: "text",
                      value: longitude ? longitude : "",
                      onChange: (e) => {
                        setLongitude(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* More settings */}
            <div className={`${card} w-full`}>
              <div className={`${sectionPad} border-b`}>
                <Title props={{ title: "More Settings" }} />
              </div>
              <div className={sectionPad}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  <Select
                    props={{
                      id: "event_status",
                      title: "Status",
                      option: ["visible", "invisible"],
                      onChange: (e) => {
                        if (e.target.selectedIndex === 0) setEventStatus(1);
                        else setEventStatus(0);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "featured",
                      title: "Featured",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        setFeatured(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "promoted",
                      title: "Promoted",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        setPromoted(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "gallery",
                      title: "Show in Gallery",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        const choice = e.target.value;
                        setExpo(choice === "no" ? 0 : 1);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Description & tags */}
            <div className={`${card} w-full`}>
              <div
                className={`${sectionPad} border-b flex items-center justify-between`}
              >
                <Title props={{ title: "Description" }} />
                <MyButton
                  onClick={() => setShowDescriptionModal(true)}
                  className="bg-blue-600 hover:bg-blue-500 text-white py-2.5 px-4 rounded-lg"
                >
                  Generate Description
                </MyButton>
              </div>
              <div className={sectionPad}>
                <TextArea
                  props={{
                    id: "description",
                    title: "Description",
                    type: "text",
                    value: description ? description : "",
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
                  <InputField
                    props={{
                      id: "hashtag",
                      title: "Tags (comma separated)",
                      type: "text",
                      value: hashtags ? hashtags : "",
                      onChange: (e) => {
                        setHashtags(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Submit */}
            <div className="w-full sticky bottom-0">
              <div className="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-t border-slate-200 px-4 sm:px-5 py-3 rounded-b-xl">
                <MyActionButton
                  loading={loading}
                  title="Add Event"
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage(null);
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;
